import { makeStyles } from '@material-ui/core';

import { pdvColor, pdvLabelFont, pdvRadius } from '../tokens';

export const useStyles = makeStyles({
  root: {
    ...pdvLabelFont,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    height: 40,
    padding: '8px 16px',
    border: 0,
    borderRadius: pdvRadius.pill,
    background: 'none',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '& .MuiSvgIcon-root': { fontSize: 18 },
    '&:focus-visible': {
      outline: 'none',
      boxShadow: `0 0 0 2px ${pdvColor.brand}`
    },
    '&:disabled': { opacity: 0.4, cursor: 'not-allowed' }
  },
  compact: { padding: '8px 12px' },

  /* solid fills keep full opacity when disabled and grey out instead */
  brand: {
    background: pdvColor.brand,
    color: pdvColor.textOnBrand,
    '&:hover:not(:disabled)': { filter: 'brightness(.95)' }
  },
  danger: {
    background: pdvColor.dangerBright,
    color: pdvColor.textOnBrand,
    '&:hover:not(:disabled)': { filter: 'brightness(.95)' }
  },
  solidDisabled: {
    '&:disabled': {
      opacity: 1,
      background: pdvColor.surfaceSubtle,
      color: pdvColor.borderStrong
    }
  },
  secondary: {
    // 1px border inside the same 40px
    padding: '7px 15px',
    border: `1px solid ${pdvColor.brand}`,
    background: pdvColor.surface,
    color: pdvColor.brand,
    '&:hover:not(:disabled)': { background: pdvColor.brandTint }
  },
  tertiary: {
    color: pdvColor.textSecondary,
    '&:hover:not(:disabled)': { background: pdvColor.surfacePage }
  },
  text: {
    color: pdvColor.brand,
    '&:hover:not(:disabled)': { background: pdvColor.brandTint }
  },
  positive: {
    color: pdvColor.successStrong,
    '&:hover:not(:disabled)': { background: pdvColor.successTint }
  },
  dangerText: {
    color: pdvColor.dangerBright,
    '&:hover:not(:disabled)': { background: pdvColor.dangerTint }
  }
});
